import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import CriticalStyles from './critical_css';
import AmpboilerplateStyle from './amp_styles';

// function DevReloading(props) {
//   if (props.env === 'development') {
//     return (
//       <script
//         dangerouslySetInnerHTML={{
//           __html: `setTimeout(function(){window.location.reload();}, 60000);`
//         }}
//       />
//     );
//   }
//
//   return null;
// }

function Head(props) {
  const meta = get(props, 'meta.meta') || [];
  const link = get(props, 'meta.link') || [];
  const script = get(props, 'meta.script') || [];
  const title = get(props, 'meta.title');

  return (
    <head>
      <meta charset="utf-8" />
      <meta
        http-equiv="origin-trial"
        content="AjQkyiCgG5iPFdJnbc/BHOxiJXzCd8tS1qO2BPNmUcjPhqTAlpCqguyW04T5U5JUik+rrEV/zE5+dMa+k3KT5gYAAABneyJvcmlnaW4iOiJodHRwczovL2Nkbi5hbXBwcm9qZWN0Lm9yZzo0NDMiLCJmZWF0dXJlIjoiV2ViU2hhcmUiLCJleHBpcnkiOjE0ODg4MTA2NjQsImlzU3ViZG9tYWluIjp0cnVlfQ=="
      />
      <link rel="canonical" href={props.canonical} />
      <meta
        name="viewport"
        content="width=device-width,minimum-scale=1,initial-scale=1"
      />
      <title>{title}</title>
      <AmpboilerplateStyle />
      {meta.map(function createMetaTags(conf) {
        return <meta key={JSON.stringify(conf)} {...conf} />;
      })}
      {link.map(function createLinkTags(conf) {
        return <link key={JSON.stringify(conf)} {...conf} />;
      })}

      <CriticalStyles amp={true} />
      {/* <DevReloading env={props.env} /> */}

      <script async src="https://cdn.ampproject.org/v0.js" />
      <script
        async
        custom-element="amp-ad"
        src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"
      />
      <script
        async
        custom-element="amp-analytics"
        src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
      />
      <script
        async
        custom-element="amp-iframe"
        src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
      />
      <script
        async
        custom-element="amp-twitter"
        src="https://cdn.ampproject.org/v0/amp-twitter-0.1.js"
      />
      <script
        async
        custom-element="amp-instagram"
        src="https://cdn.ampproject.org/v0/amp-instagram-0.1.js"
      />
      <script
        async
        custom-element="amp-facebook"
        src="https://cdn.ampproject.org/v0/amp-facebook-0.1.js"
      />

      <script
        async
        custom-element="amp-youtube"
        src="https://cdn.ampproject.org/v0/amp-youtube-0.1.js"
      />

      <script
        async
        custom-element="amp-vimeo"
        src="https://cdn.ampproject.org/v0/amp-vimeo-0.1.js"
      />

      <script
        async
        custom-element="amp-sticky-ad"
        src="https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js"
      />

      <script
        async
        custom-element="amp-carousel"
        src="https://cdn.ampproject.org/v0/amp-carousel-0.1.js"
      />

      <script
        async
        custom-element="amp-anim"
        src="https://cdn.ampproject.org/v0/amp-anim-0.1.js"
      />

      <script
        async
        custom-element="amp-jwplayer"
        src="https://cdn.ampproject.org/v0/amp-jwplayer-0.1.js"
      />

      <script
        async
        custom-element="amp-sidebar"
        src="https://cdn.ampproject.org/v0/amp-sidebar-0.1.js"
      />

      <script
        async
        custom-element="amp-fit-text"
        src="https://cdn.ampproject.org/v0/amp-fit-text-0.1.js"
      />

      <script
        async
        custom-element="amp-social-share"
        src="https://cdn.ampproject.org/v0/amp-social-share-0.1.js"
      />

      <script
        async
        custom-element="amp-video"
        src="https://cdn.ampproject.org/v0/amp-video-0.1.js"
      />

      <script
        async
        custom-element="amp-audio"
        src="https://cdn.ampproject.org/v0/amp-audio-0.1.js"
      />
    </head>
  );
}

function mapStateToProps(state) {
  return {
    env: state.config.env,
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: PropTypes.shape({}).isRequired,
  canonical: PropTypes.string.isRequired
  // env: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(Head);



// WEBPACK FOOTER //
// ./src/views/components/head/amp_head.js